module.exports = __webpack_public_path__ + "static/media/component-8.525ab6fb.svg";